import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import Constants from 'constants/Constants';

// -- utils
import AbstractComponent from 'components/AbstractComponent';
import DateUtils from 'PMT/utils/DateUtils';

// -- entities
import AvailabilityHour from 'PMT/entities/menu/AvailabilityHour';

// -- views
import { Modal } from 'react-bootstrap';
import DayChooser from 'components/DayChooser';
import HourChooser from 'PMT/components/form/HourChooser';

class AddAvailabilityHourModal extends AbstractComponent {

  static defaultProps = {
    defaultAvailabilityHour: new AvailabilityHour(),
    defaultDay: Constants.Day.MONDAY
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    // -- params: Number (Day), availabilityHour (AvailabilityHour)
    onAddAvailabilityHourForDay: PropTypes.func.isRequired,

    defaultAvailabilityHour: PropTypes.instanceOf(AvailabilityHour),

    defaultDay: PropTypes.number
  };

  state = {
    day: this.props.defaultDay,

    availabilityHour: this.props.defaultAvailabilityHour
  };


  // -- events

  onAvailabilityHourChange = (opening: number) => {
    const availabilityHour: AvailabilityHour = this.state.availabilityHour;
    availabilityHour.opening = opening;

    this.setState({
      availabilityHour
    });
  };

  onClosingHourChange = (closing: number) => {
    const availabilityHour: AvailabilityHour = this.state.availabilityHour;
    availabilityHour.closing = closing;

    this.setState({
      availabilityHour
    });
  };

  onDayChange = (value: number) => {
    this.setState({
      day: value
    });
  };

  onSubmit = (event) => {
    event.preventDefault();

    const availabilityHour: AvailabilityHour = this.state.availabilityHour;

    // TODO: validation
    if (availabilityHour.closing - availabilityHour.opening <= 0) {
      // TODO: display error invalid range.
    } else {
      this.props.onAddAvailabilityHourForDay(this.state.day, availabilityHour);
      this.props.onHide();
    }
  };

  // -- renderers

  renderDayPicker() {
    return (
      <DayChooser
        day={this.state.day}
        onChange={this.onDayChange}
      />
    );
  }

  renderAvailabilityHour() {
    return (
      <HourChooser
        onChange={this.onAvailabilityHourChange}
        defaultValue={this.state.availabilityHour.opening}
      />
    );
  }

  renderClosingHour() {
    return (
      <HourChooser
        onChange={this.onClosingHourChange}
        defaultValue={this.state.availabilityHour.closing}
        withEndOfDay
      />
    );
  }

  renderBody() {
    return (
      <div>
        <form
          className="form form-horizontal booking_form"
          role="form"
          noValidate
          onSubmit={this.onSubmit}
        >

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.day')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderDayPicker()}
            </div>
          </div>

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.opening')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderAvailabilityHour()}
            </div>
          </div>

          <div className="form-group">
            <div className="required col-xs-4 control-label">
              <label>
                {I18n.tr('components.opening_hours.form_modal.closing')}
              </label>
            </div>
            <div className="col-xs-6">
              {this.renderClosingHour()}
            </div>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-primary"
              onClick={this.onSubmit}
            >
              {I18n.tr('components.opening_hours.form_modal.create')}
            </button>
          </div>

        </form>
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.props.onHide}
          >
            <i className="pmt pmt-cancel" />
          </button>

          <Modal.Title>
            {I18n.tr('components.opening_hours.form_modal.title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }

}

export default AddAvailabilityHourModal;
